/*eslint camelcase: "error"*/

export const defaultConfig = {
    api: '',
    web: '',
    websocket: '',
    consoleLogLevel: 'warn',
    podName: '',
    podRegion: '',
    environment: ''
};

export type DefaultConfig = typeof defaultConfig;
